export {
  default as brush,
  brushX,
  brushY,
  brushSelection
} from "./src/brush";



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-brush/index.js
// module id = STk2
// module chunks = 0